// extracted by mini-css-extract-plugin
export var actions = "_11-0";
export var actionsContainer = "_11-6";
export var border = "_11-1";
export var childFullHeight = "_11-d";
export var collapse = "_11-2";
export var content = "_11-8";
export var contentChild = "_11-c";
export var fullscreen = "_11-a";
export var headerContainer = "_11-3";
export var headerRow = "_11-5";
export var hidePadding = "_11-9";
export var noScrollX = "_11-e";
export var noScrollY = "_11-f";
export var optOutTopPadding = "_11-b";
export var pagePadding = "_11-7";
export var profile = "_11-g";
export var profileContainer = "_11-h";
export var profileImage = "_11-i";
export var profileMain = "_11-j";
export var profileSubtitle = "_11-l";
export var profileTitle = "_11-k";
export var tabsWrapper = "_11-4";
export var title = "_11-m";